/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_Test_CvInputs */

const en_admin_sidebar_test_cv = /** @type {(inputs: Admin_Sidebar_Test_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test CV (DEV/QA)`)
};

const de_admin_sidebar_test_cv = /** @type {(inputs: Admin_Sidebar_Test_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf testen (DEV/QA)`)
};

/**
* | output |
* | --- |
* | "Test CV (DEV/QA)" |
*
* @param {Admin_Sidebar_Test_CvInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_test_cv = /** @type {((inputs?: Admin_Sidebar_Test_CvInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_Test_CvInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_test_cv(inputs)
	return en_admin_sidebar_test_cv(inputs)
});